import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var HyperHireRoutes = {
    "/social-referral-settings": {
        "enableUTM": true,
        "showGlobalSearch": false,
        "name": "social_referral_settings",
        "type": "backend-frontend",
        "templateUrl": "../hmodules/hyper-hire/controllers/manage-lists/manage-lists.html",
        "controller": "ManageLists",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },
        ],
        route_styles: {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Referral Lists | HARRI"
            },
            {
                "tag": "meta",
                "attributes": {
                    "property": "og:title",
                    "content": "Employee Referral Lists | HARRI"
                }
            }
        ],
    },
    "/brand/:brand_id/social-referral": {
        "name": "appLayout.harriSH.social-referral-templates",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'socialReferralContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            },
        ]
    },

    [`/social-referral/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.settings.social-referral-templates",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "showSettingsHeader": true,
        "component": 'socialReferralContainer',
        "onEnter": ['$stateParams', '$state', 'hmapService', 'brandServices', async function ($stateParams, $state, hmapService, brandServices) {
            const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
            const isSocialReferralEnabled = await brandServices.check(brandServices.SERVICES.SOCIAL_REFERRAL, activeBrandId);

            if (!isSocialReferralEnabled) {
                Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams['hmapPath']});
            }

            const gpPolicy = await hmapService.loadGPPlociy(activeBrandId);
            const activeBrandPolicy = gpPolicy?.brands?.find((entry) => entry.id === activeBrandId);

            if (activeBrandPolicy?.actions[0] !== 'ALL') {
                Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams['hmapPath']});
            }
        }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            },
        ]
    },

    "/social-unsubscribe?token": {
        "name": "social-unsubscribe",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'socialReferralUnsubscribeContainer',
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            }
        ]
    }

};
